import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function checkToken(data: { token: string }) {
	error.value = null;
	try {
		const res = await $api.staff.validateStaffToken(data);
		return res?.data;
	} catch (err) {
		error.value = err;
	} finally {
		loading.value = false;
	}
}

export function useCheckToken() {
	return { checkToken__error: error, loading, checkToken };
}
